import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import { getCrmMasterCuisinesEndpointIdentifier, ICrmMasterCuisineData } from './use-get-crm-master-cuisines-api';

const endpoint = 'ums/v1/crm/management/master-cuisines';

export type CreateCrmMasterCuisinePayload = {
  name: string;
  region?: string;
  country?: string;
};

type TData = ICrmMasterCuisineData;
type TError = AxiosError;
type TVariables = CreateCrmMasterCuisinePayload;

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

export function useCreateCrmMasterCuisineApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async (payload: TVariables): Promise<TData> => {
    const { data } = await http.post(endpoint, payload);
    return data;
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: endpoint,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([getCrmMasterCuisinesEndpointIdentifier]);
      if (userOnSuccess) {
        userOnSuccess(data, variables, context);
      }
    },
    ...restOptions,
  });
}
